import styled from 'styled-components';

export const Container = styled.div`
  .ant-skeleton-element, .ant-skeleton-button {
    width: 100%;
  }
`;
